/** @file placeEntityRoot: the entity root at the entity's display position, world z scaled by zScaleView. */
import type { TransformNode } from '@babylonjs/core/Meshes/transformNode.js';
import type { Vec3 } from '@zilo/pose3d-math/vec3/vec3';
import { displayOf } from '@zilo/pose3d-runtime-babylon/camera/displayOf';
import { toBabylonVec3 } from '@zilo/pose3d-runtime-babylon/camera/toBabylonVec3';

/** `position = toBabylonVec3(displayOf(entityPos, zScaleView))`, `scaling = (1, zScaleView, 1)` (Babylon y is world z, 17.7). */
export function placeEntityRoot(root: TransformNode, entityPos: Vec3, zScaleView: number): void {
  toBabylonVec3(displayOf(entityPos, zScaleView), root.position);
  root.scaling.set(1, zScaleView, 1);
}
